namespace Areas.Projects {
    "use strict";

    var selected: Selected = new Selected();


    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Projects/ProjectUsers/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    //select Account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ProjectsForm").dxForm("instance");
            const formData: any = form.option("formData");
    

            formData.AccountId = data.accountId;
            formData.NonPlantAccountId = data.nonPlantAccountId;
            formData.ProjectName = data.accountShortName;
            formData.ProjectNumber = data.projectCCNumber;
            formData.ProjectManagerName = data.pmName;
            formData.ProjectManagerEmail = data.pmEmail;

            
            if (data.gpsCoordinates == null || data.gpsCoordinates == '') {
                formData.GPSCoordinates = '34.0462,-118.4422';
            } else {
                formData.GPSCoordinates = data.gpsCoordinates;
            }

            
            form.option("formData", formData);

        }
    }

    export function selectAccount() {
        const form: any = $("#ProjectsForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.Account.AccountDialog(accountDialogClosing());
    }

    export function selectProjectManager() {
        const form: any = $("#ProjectsForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.ContactDialog(dialogContactClosing());
    }

    function dialogContactClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ProjectsForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.ProjectManagerName = data.displayName;
            formData.ProjectManagerEmail = data.primaryEMail;
            
            form.option("formData", formData);
        }
    } 

    export function showGpsDialog() {
        const form = $("#ProjectsForm").dxForm("instance");
        const formData: any = form.option("formData");        
        const dialogGps = new Dialogs.Gps.GpsDialog(updateBuildingGps, formData.GPSCoordinates);       
    }

    function updateBuildingGps(dialogResult: DialogResult, data: any) {
        
        if (dialogResult === DialogResult.Cancel) return;

        const form = $("#ProjectsForm").dxForm("instance");
        const formData: any = form.option("formData");

        if (data) {
            formData.GPSCoordinates = data;
            form.option("formData", formData);    
        }
    }



}